<template>
    <v-container>
        <monarchs></monarchs>
        <governors-general></governors-general>        
    </v-container>
</template>
<script>

import GovernorsGeneral from './GovernorsGeneral.vue';
import Monarchs from './Monarchs.vue';

import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    components: {
        GovernorsGeneral,
        Monarchs
    }
}
</script>
